import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { DxUserRole } from "./dx-user-role";
import { DxUserPrivilege } from "./dx-user-privilege";
import { Privileges } from "../../../bdpk-common/domain/privileges.enum";
/**
 * В чем соль и боль:
 * Разные методологии\сервисы для аунтификации пользователя обычно возвращают
 * различный набор данных, но приложение в своей работе должно опираться на что-то одно
 * в контексте необходимого и достаточного состава полей.
 **/
let DxUserSession = class DxUserSession {
    /**
     * В чем соль и боль:
     * Разные методологии\сервисы для аунтификации пользователя обычно возвращают
     * различный набор данных, но приложение в своей работе должно опираться на что-то одно
     * в контексте необходимого и достаточного состава полей.
     **/
    constructor() {
        /** Блокировка пользователя **/
        this.locked = false;
        /** Признак необходимости актуализации информации о пользователе. **/
        this.reload = false;
        this.roles = [];
        this.privileges = [];
        /**
         * @param id - look {@link Privileges}
         */
        this.containsPrivilegeId = (id) => {
            if (this.privileges.find(privilege => privilege.id === Privileges.ALLOW_ALL)) {
                return true;
            }
            return !!this.privileges.find(privilege => privilege.id === id);
        };
        this.containsPrivilegeIds = (...ids) => {
            return !!ids.find(id => this.containsPrivilegeId(id));
        };
    }
    // [
    //   new DxUserPrivilege({id: Privileges.TASK_REGISTRY}),
    //   new DxUserPrivilege({id: Privileges.OBJECT_REGISTRY}),
    //   new DxUserPrivilege({id: Privileges.SCHEDULE_REGISTRY}),
    //   new DxUserPrivilege({id: Privileges.SCHEDULER_LOGS}),
    //   new DxUserPrivilege({id: Privileges.OPEN_OF_DEV_ENVS}),
    //   new DxUserPrivilege({id: Privileges.USER_RIGHTS_ADM}),
    // ];
    /**
     * @param id - look {@link Roles}
     */
    containsRoleId(id) {
        return !!this.roles.find(role => role.id === id);
    }
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxUserSession.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserSession.prototype, "login", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserSession.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserSession.prototype, "position", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserSession.prototype, "token", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxUserSession.prototype, "tokenExpTime", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserSession.prototype, "refreshToken", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxUserSession.prototype, "refreshTokenExpTime", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserSession.prototype, "description", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserSession.prototype, "email", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxUserSession.prototype, "locked", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxUserSession.prototype, "reload", void 0);
tslib_1.__decorate([
    jsonArrayMember(DxUserRole, { emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxUserSession.prototype, "roles", void 0);
tslib_1.__decorate([
    jsonArrayMember(DxUserPrivilege, { emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxUserSession.prototype, "privileges", void 0);
DxUserSession = tslib_1.__decorate([
    jsonObject
], DxUserSession);
export { DxUserSession };
